import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import { ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const InfinityScroll = (props) => {
  const {
    title,
    saveIcon,
    saveLink,
    saveName,
    searchPlaceholder,
    handleChangeValue,
    hadlesearchValue,
    handleChangeValueClick,
    handleRowSelection,
    row,
    column,
    selectedValue,
    onChange,
    searchValue,
    searchFlag,
  } = props;
  const currentUrl = window.location.href;

  //너비 설정
  const [columnWidths, setColumnWidths] = useState(
    column.map((col) => parseInt(col.width, 10)),
  );

  const handleResize = (index, event, { size }) => {
    setColumnWidths((prevWidths) => {
      const newWidths = [...prevWidths];
      newWidths[index] = size.width;
      return newWidths;
    });
  };

  const totalWidth = columnWidths.reduce((acc, width) => acc + width, 0);
  const remainingWidth = 1150 - totalWidth;

  return (
    <>
      <div className="fixed-header">
        <div>
          <div className="header-row">
            <div className="title">{title}</div>
            <button>
              <Link to={saveLink}>
                {saveIcon}
                <button
                  className="blue"
                  style={{ fontSize: '16px', fontWeight: '600' }}
                >
                  {saveName}
                </button>
              </Link>
            </button>
          </div>
        </div>
        <div className="search-bar">
          {/* {!currentUrl.includes('device') && ( */}
          {searchFlag && (
            <RadioGroup
              value={selectedValue}
              onChange={onChange}
              row
              name="radio-buttons-group"
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'center',
                width: '250px',
                height: '38px',
              }}
            >
              <FormControlLabel
                style={{ marginRight: '40px' }}
                value="Name"
                control={
                  <Radio
                    sx={{
                      color: '#3F598C',
                      '&.Mui-checked': {
                        color: '#3F598C',
                      },
                    }}
                  />
                }
                label="Name"
              />
              <FormControlLabel
                value="Email"
                control={
                  <Radio
                    sx={{
                      color: '#3F598C',
                      '&.Mui-checked': {
                        color: '#3F598C',
                      },
                    }}
                  />
                }
                label="Email"
              />
            </RadioGroup>
          )}
          <TextField
            label={searchPlaceholder}
            onKeyDown={handleChangeValue}
            onChange={hadlesearchValue}
            style={{ width: '95%' }}
            value={searchValue}
          />
          <button>
            <button onClick={handleChangeValueClick}>
              <SearchIcon />
            </button>
          </button>
        </div>

        <div className="table-header-container">
          <div className="table-header">
            {column.map((col, id) => {
              return (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                  key={id}
                >
                  <ResizableBox
                    minConstraints={[100, 0]}
                    maxConstraints={[
                      Math.min(400, remainingWidth + columnWidths[id]),
                      0,
                    ]}
                    width={columnWidths[id]}
                    height={30}
                    axis="x"
                    resizeHandles={['e']}
                    onResize={(e, { size }) => handleResize(id, e, { size })}
                  >
                    <div className="table-header-cell">{col.value}</div>
                  </ResizableBox>
                </div>
              );
            })}
          </div>
        </div>
        <div className="horizontal-line"></div>
      </div>

      <div className="content-container">
        {row.map((data, id) => {
          return (
            <div key={id}>
              <button
                className="row-button"
                onClick={() => handleRowSelection(data.data1.value)}
              >
                <div className="row-content">
                  {Object.keys(data).map((key, index) => {
                    return (
                      <div
                        className="cell"
                        style={{
                          width: columnWidths[index],
                        }}
                        key={index}
                      >
                        <div className="cell-content">{data[key].value}</div>
                      </div>
                    );
                  })}
                </div>
              </button>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default InfinityScroll;
